export default __webpack_public_path__ + "images/18aa13bd-arrow_forward_ios_black_24dp.svg";